var map = {
	"./di10ming.png": 952,
	"./di1ming.png": 953,
	"./di2ming.png": 954,
	"./di3ming.png": 955,
	"./di4ming.png": 956,
	"./di5ming.png": 957,
	"./di6ming.png": 958,
	"./di7ming.png": 959,
	"./di8ming.png": 960,
	"./di9ming.png": 961
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 951;


//////////////////
// WEBPACK FOOTER
// ./src/modules/theme/components/springImage ^\.\/di.*ming\.png$
// module id = 951
// module chunks = 0